export default __webpack_public_path__ + "static/media/standout5.ac0aec0a.png";